<div class="container">
	<h1>Hiba</h1>
	<ng-content></ng-content>
</div>
